import $ from 'jquery'
import slick from 'slick-carousel';
import SmoothScroll from 'smooth-scroll';

/*!--------------------------------------------------------------------------*
 *
 *  jquery.heightLine.js
 *
 *  MIT-style license.
 *
 *  2013 Kazuma Nishihata
 *  http://www.to-r.net
 *
 *--------------------------------------------------------------------------*/

;(function($){
  $.fn.heightLine = function(){
    var target = this,fontSizeChangeTimer,windowResizeId= Math.random();
    var heightLineObj = {
      op : {
        "maxWidth" : 10000,
        "minWidth" : 0,
        "fontSizeCheck" : false
      },
      setOption : function(op){
        this.op = $.extend(this.op,op);
      },
      destroy : function(){
        target.css("height","");
      },
      create : function(op){
        var self = this,
          maxHeight = 0,
          windowWidth = $(window).width();
        self.setOption(op);
        if( windowWidth<=self.op.maxWidth && windowWidth>=self.op.minWidth ){
          target.each(function(){
            if($(this).outerHeight()>maxHeight){
              maxHeight = $(this).outerHeight();
            }
          }).each(function(){
            var height = maxHeight
                   - parseInt($(this).css("padding-top"))
                   - parseInt($(this).css("padding-bottom"));
            $(this).height(height);
          });
        }
      },
      refresh : function(op){
        this.destroy();
        this.create(op);
      },
      removeEvent :function(){
        $(window).off("resize."+windowResizeId);
        target.off("destroy refresh");
        clearInterval(fontSizeChangeTimer);
      }
    }
    if(typeof arguments[0] === "string" && arguments[0] === "destroy"){
      target.trigger("destroy");
    }else if(typeof arguments[0] === "string" && arguments[0] === "refresh"){
      target.trigger("refresh");
    }else{
      heightLineObj["create"](arguments[0]);

      $(window).on("resize."+windowResizeId,function(){
        heightLineObj["refresh"]();
      });

      target.on("destroy",function(){
        heightLineObj["removeEvent"]();
        heightLineObj["destroy"]();
      }).on("refresh",function(){
        heightLineObj["refresh"]();
      });

      if(heightLineObj.op.fontSizeCheck){

        if($("#fontSizeChange").length<=0){
          var fontSizeChange = $("<span id='fontSizeChange'></span>").css({
            width:0,
            height:"1em",
            position:"absolute",
            left:0,
            top:0
          }).appendTo("body");
        }
        var defaultFontSize = $("#fontSizeChange").height();
        fontSizeChangeTimer = setInterval(function(){
          if(defaultFontSize != $("#fontSizeChange").height()){
            heightLineObj["refresh"]();
          }
        },100);
      }
    }
    return target;
  }
})($);

var MAIN = MAIN || {};

/* ================================================== *
/*
/*    function
/*
/* ================================================== */

MAIN.fn = {};

/* ------------------------------------------------- *
 *        detectDevice1
 * ------------------------------------------------- */

MAIN.fn.deviceCheck1 = {
  emt: {
    ua      : '',
    ver     : '',
    ie      : '',
    browser : '',
    device  : '',
  },
  init: function() {
    var emt = this.emt;
    emt.ua = navigator.userAgent.toLowerCase();
    emt.ver = navigator.appVersion.toLowerCase();

    var detectIE = function(){
      if (emt.ver.indexOf('msie 6.') >= 0) {
        emt.ie = 'ie6';
      }
      else if (emt.ver.indexOf('msie 7.') >= 0) {
        emt.ie = 'ie7';
      }
      else if (emt.ver.indexOf('msie 8.') >= 0) {
        emt.ie = 'ie8';
      }
      else if (emt.ver.indexOf('msie 9.') >= 0) {
        emt.ie = 'ie9';
      }
      else if (emt.ver.indexOf('msie 10.') >= 0) {
        emt.ie = 'ie10';
      }
      else {
        emt.ie = 'other';
      }
    }();

    var detectBrowser = function(){
      if (emt.ua.indexOf('chrome') >= 0) {
        emt.browser = 'chrome';
      }
      else if (emt.ua.indexOf('safari') >= 0) {
        emt.browser = 'safari';
      }
      else if (emt.ua.indexOf('opera') >= 0) {
        emt.browser = 'opera';
      }
      else if (emt.ua.indexOf('firefox') >= 0) {
        emt.browser = 'firefox';
      }
      else if (emt.ua.indexOf('trident/7') >= 0) {
        emt.browser = 'ie11';
      }
      else if (emt.ua.indexOf("msie") >= 0) {
        emt.browser =  detectIE();
      }
    }();

    var detectDevice = function(){
      if ((emt.ua.indexOf('android') > 0 && emt.ua.indexOf('mobile') === -1 ) || emt.ua.indexOf('ipad') > 0) {
        emt.device = 'tb';
      }
      else if ((emt.ua.indexOf('iphone') > 0 && emt.ua.indexOf('ipad') === -1 ) || emt.ua.indexOf('ipod') > 0 || (emt.ua.indexOf('android') > 0 && emt.ua.indexOf('mobile') > 0)) {
        emt.device = 'sp';
      }
      else {
        emt.device = 'pc';
      }
    }();

    if(emt.browser.indexOf('ie') >= 0){
      $('body').addClass('is-ie');
    }
    $('body').addClass('is-'+emt.browser).addClass('is-'+emt.device);
  }
}

/* ------------------------------------------------- *
/*        kv1
/* ------------------------------------------------- */

MAIN.fn.kv1 = {
  emt: {
    catch : '.js-kv1__catch1',
    slide : '.js-kv1__slide1',
  },
  catch: function () {
    var emt = this.emt;
    $(emt.catch).addClass('-active');
  },
  slide: function () {
    var emt = this.emt;
    $(emt.slide).slick({
      infinite: false,
      dots: true,
      autoplay: true,
      autoplaySpeed: 5000,
      slidesToShow: 1,
      slidesToScroll: 1,
        // variableWidth: true,
      // centerMode: true,
      responsive: [
        {
          breakpoint : 1024,
          settings : {
          }
        }
      ]
    });
  }
};

/* ------------------------------------------------- *
/*        book
/* ------------------------------------------------- */

MAIN.fn.book1 = {
  emt: {
    book : '.js-kv1__list1 ul',
  },
  init: function (emt) {
    var emt = this.emt;
    var count = 1;
    var fadein = setInterval(function(){
      if( count <= 27 ){
        $(":nth-child("+count+")",emt.book).addClass('-effect');
        count++;
      } else {
        $("li",emt.book).removeClass('-effect');
      }
    },75);
    var random = setInterval(function(){
      $("li",emt.book).removeClass('-active');
      var random = Math.floor(Math.random() * ((27 + 1) - 1)) + 1;
      $(":nth-child("+random+")",emt.book).addClass('-active');
    },2500);
  }
};

/* ------------------------------------------------- *
/*        nav1
/* ------------------------------------------------- */

MAIN.fn.nav1 = {
  emt: {
    btnOpen : '.js-nav1__btnOpen1',
    body    : '.js-nav1__body1',
    spd     : 350
  },
  init: function () {
    var emt = this.emt;
    $(emt.btnOpen).on('click', function(){
      if( $(emt.btnOpen).hasClass('-active') ){
        $(emt.btnOpen).removeClass('-active')
        $(emt.body).fadeOut(emt.spd)
      } else {
        $(emt.btnOpen).addClass('-active')
        $(emt.body).fadeIn(emt.spd)
      }
    });
  }
};

/* ------------------------------------------------- *
/*        smooth-scroll1
/* ------------------------------------------------- */

MAIN.fn.smoothScroll1 = {
  init: function() {
    var scroll = new SmoothScroll('.js-smooth',{
      speed  : 500,
      easing : 'easeOutQuint'
    });
  }
}

/* ------------------------------------------------- *
/*        block13
/* ------------------------------------------------- */

MAIN.fn.block13 = {
  t: {
    module : '.block13',
  },
  init: function() {
    var t = this.t;
    $(t.module).find('.block13__unit1__frame1').heightLine({
      minWidth:992
    });
  },
};

/* ================================================== *
/*
/*    run
/*
/* ================================================== */

$(document).ready(function () {
  MAIN.fn.deviceCheck1.init();
  MAIN.fn.nav1.init();
  MAIN.fn.kv1.catch();
  MAIN.fn.kv1.slide();
  MAIN.fn.book1.init();
  MAIN.fn.block13.init();
  MAIN.fn.smoothScroll1.init();
});
